/* lua.js generated code 0.3.0 */

var InfiniteEnergyBar = {}
InfiniteEnergyBar.create = function (layout) {
    var mask = layout.getChildByName("mask")
    layout.getChildByName("light").setScale(1.008)
    var {x: posX, y: posY} = mask.getPosition()
    var newMask = cc.Sprite.createWithSpriteFrameName("homeScene/colormask.png")
    newMask.setScaleX(1.16)
    newMask.setPosition(posX + newMask.getContentSize().width * newMask.getScaleX() / 2, posY - newMask.getContentSize().height / 2)
    mask.removeFromParent(true)
    var clipNode = cc.ClippingNode.create(newMask)
    clipNode.setPosition(0, 0)
    clipNode.setAlphaThreshold(0.5)
    layout.addChild(clipNode, -1)
    var colorBar = cc.Sprite.createWithSpriteFrameName("homeScene/colorbar.png")
    colorBar.setAnchorPoint(cc.p(0, 1))
    colorBar.setPosition(0, posY)
    clipNode.addChild(colorBar)
    colorBar.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.MoveTo.create(5, cc.p(-colorBar.getContentSize().width / 3 * 2, posY)), cc.CallFunc.create(function () {
        var __VA_ARG = $slice(arguments, 0)
        colorBar.setPosition(0, posY)
    }))))
    return layout
}
module.exports = InfiniteEnergyBar
